import React from 'react';

type LoadingProps = {
  message?: string;
  size?: number;
};

const Loading: React.FC<LoadingProps> = ({ message = 'Loading…', size = 48 }) => {
  return (
    <div className="loading-screen">
      <div
        className="loading-spinner"
        style={{ width: size, height: size }}
        aria-hidden
      />
      <div className="loading-message">{message}</div>
    </div>
  );
};

export default Loading;
